<template>
  <div class="customer-pool">
    <div class="header">
      <div class="title border-bottom" @click="visible = 'pool'">
        <span>{{ poolName }}</span>
        <van-icon name="arrow-down" />
      </div>
      <FilterCustomer @queryList="queryCustomer" />
    </div>
    <div class="content">
      <template v-if="list.length">
        <RenderItem v-for="item in list" :key="item.id" :dataItem="item">
          <template v-slot:footer>
            <div class="operate">
              <van-button size="small" @click="handleOperate(item, 'staff')">指派</van-button>
              <van-button size="small" @click="handleOperate(item, 'move')">移动</van-button>
            </div>
          </template>
        </RenderItem>
      </template>
      <van-empty v-else description="暂无数据" />
    </div>
    <div class="page">
      <span class="page-count">共{{ totalCount }}条数据</span>
      <Pagination v-bind.sync="page" :totalCount="totalCount" />
    </div>
    <!-- 员工列表 -->
    <van-popup :value="visible === 'staff'" position="bottom" round :style="{ height: '40%' }"
      @click-overlay="visible = ''">
      <van-search v-model="searchText" placeholder="请输入员工姓名" @search="onSearch" />
      <van-picker title="选择要指派跟进的员工" show-toolbar :columns="filteredStaffList" value-key="name" @cancel="visible = ''"
        @confirm="handleConfirm($event, 'staff')" />
    </van-popup>
    <!-- 公海列表 -->
    <van-popup :value="visible === 'pool' || visible === 'move'" position="bottom" round :style="{ height: '40%' }"
      @click-overlay="visible = ''">
      <van-picker :title="`${visible === 'pool' ? '请选择公海' : '选择要移入的公海'}`" show-toolbar :columns="poolOptions"
        value-key="name" @cancel="visible = ''"
        @confirm="handleConfirm($event, visible === 'pool' ? 'pool' : 'move')" />
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { customerPoolList, getCustomerList, batchUpdateCustomer } from '@/api/customer'
import Pagination from '@/components/pagination'
import RenderItem from '../customer/components/renderItem'
import FilterCustomer from '../customer/components/filters'
export default {
  name: 'PoolList',
  components: { Pagination, RenderItem, FilterCustomer },
  data() {
    return {
      visible: '',
      poolName: '请选择公海',
      poolOptions: [],
      page: {
        currentPage: 1,
        currentCount: 10
      },
      list: [],
      query: {
        type: 1
      },
      totalCount: 0,
      customerId: undefined,
      customerPoolId: undefined,
      searchText: '',
    }
  },
  computed: {
    ...mapGetters(['staffList']),
    filteredStaffList() {
      return this.searchText
        ? this.staffList.filter(item => item.name.includes(this.searchText))
        : this.staffList
    }
  },
  watch: {
    page: {
      handler() {
        this.getCustomerList(this.query)
      },
      deep: true
    }
  },
  created() {
    this.getPoolList()
    if (!this.staffList || !this.staffList.length) {
      this.$store.dispatch('user/getStaffList', { page: 1, count: 1000 })
    }
  },
  methods: {
    onSearch() {
      this.staffList = this.staffList.filter(item =>
        item.name.includes(this.searchText)
      );
    },
    handleConfirm(val, key) {
      this.visible = ''
      switch (key) {
        case 'pool':
          this.poolName = val.name
          this.customerPoolId = val.id
          this.getCustomerList(this.query)
          break
        case 'staff': // 指派跟进员工
          batchUpdateCustomer({ ids: [this.customerId], followUpPersonId: val.id }).then((res) => {
            if (res.errcode === 0) {
              this.$toast.success('指派跟进员工成功')
              this.getCustomerList()
            }
          })
          break
        case 'move': // 移入公海
          batchUpdateCustomer({ ids: [this.customerId], customerPoolId: val.id }).then((res) => {
            if (res.errcode === 0) {
              this.$toast.success('指派跟进员工成功')
              this.getCustomerList()
            }
          })
          break
        default:
          break
      }
    },
    handleOperate(item, type) { // 指派跟进员工 || 移入公海
      this.visible = type
      this.customerId = item.id
    },
    queryCustomer(params) { // 查询客户列表
      this.query = { ...params }
      this.getCustomerList(params)
    },
    getCustomerList(query) {
      const { currentPage, currentCount } = this.page
      const params = {
        page: currentPage,
        count: currentCount,
        customerPoolId: this.customerPoolId,
        limitRole: 1,
        ...query
      }
      getCustomerList(params).then((res) => {
        if (res.errcode === 0) {
          this.list = res.data
          this.totalCount = res.page.totalCount
        }
      })
    },
    getPoolList() {
      // 获取公海池列表
      customerPoolList({ page: 1, count: 2000 }).then(res => {
        if (res.errcode === 0) {
          this.poolOptions = res.data
          res.data.find((item) => {
            if (item.id === 1) { // 公海id等于1，说明是默认公海
              this.poolName = item.name
              this.customerPoolId = item.id
              this.getCustomerList(this.query)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.customer-pool {
  height: 100vh;

  .header {
    .title {
      display: flex;
      justify-content: space-between;
      padding: 15px 16px;
      background-color: #fff;
      color: #dcdee0;

      span {
        font-size: 14px;
        color: #333;
      }
    }
  }

  .content {
    min-height: calc(~'100% - 135px');

    .operate {
      display: flex;
      width: 100%;
      padding: 0;

      .van-button {
        flex: 1;
        color: #1989fa;

        &:not(:last-of-type)::after {
          content: '';
          position: absolute;
          width: 1px;
          height: 100%;
          right: 0;
          bottom: 0;
          border-right: 1px solid #ebedf0;
          transform: scaleX(0.5);
        }
      }
    }
  }

  .page {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    margin-top: 5px;

    &-count {
      font-size: 14px;
      white-space: nowrap;
    }

    .van-pagination {
      padding: 0;
    }
  }
}
</style>
